export default () => ({
  alignLeft: {
    textAlign: "left",
  },
});
